import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Group, Button } from './styles';

const ButtonGroup = ({ options, resetOption, value, onSelect }) => {
  const handleSelect = event => {
    const { value } = event.target.dataset;
    onSelect(value);
  };

  const renderFilterButton = (option, currentValue, isReset) => {
    const { label, value, ...props } = option;

    return (
      <Button
        key={label}
        title={label}
        data-value={value}
        isChecked={isReset ? currentValue === '' : currentValue === value}
        onClick={handleSelect}
        {...props}
      >
        {label}
      </Button>
    );
  };

  return (
    <Wrapper>
      <Group>
        {options.map(option => renderFilterButton(option, value, false))}
        {resetOption && renderFilterButton(resetOption, value, true)}
      </Group>
    </Wrapper>
  );
};

ButtonGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  resetOption: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }),
  value: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
};

ButtonGroup.defaultProps = {
  resetOption: null,
  onSelect: () => {},
};

export default ButtonGroup;
